<template>
  
  <v-dialog v-model="dialog" persistent max-width="500px" > 
               <!-- v-if="user.email" -->
    <p v-if="errorMessage != ''" class="mt-4 caption red--text text--darken-4">{{errorMessage}}</p>
      <v-card>
        <v-card-title>
          <span class="headline">Edit Profile</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
             <v-form style="    width: 94%;">

                      <v-text-field
              name="input-1"
              label="Username"
              v-model="name"
              id="testing"
              :error-messages="nameErrors"

  
      @input="$v.name.$touch()"
      @blur="$v.name.$touch()"
      
      required
            ></v-text-field>

                <v-text-field v-if="user.email"
                class=""
                  label="E-mail"
                  v-model="email"
                  :error-messages="emailErrors"
                  @input="$v.email.$touch()"
                   @blur="$v.email.$touch()"
                     @keydown="errorMessage=''"
                  required
                ></v-text-field>

                      <v-text-field
              name="input-10-1"
              label="Password"

              v-model="password"
              min="8"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
              counter
              :error-messages="passwordErrors"
                  @input="$v.password.$touch()"
                   @blur="$v.password.$touch()"
                  required
            ></v-text-field>

            <v-text-field
              name="input-10-1"
              label="Repeat Password"
              type="password"
              v-model="repeatPassword"
              :error-messages="repeatPasswordErrors"
                  @input="$v.repeatPassword.$touch()"
                   @blur="$v.repeatPassword.$touch()"
                  required
            ></v-text-field>
            
            <v-layout row justify-center>
                   <v-btn style="width:215px;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : status }"
                                        :loading="loading"
                                        @click="clickInputMain()"
                                        >Profile Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                                                                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                                <input type="file"  name="avatar" style="display:none" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, -1); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput1">
                                </form>
            </v-layout>
            
            
            
                  </v-form>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.stop="$emit('clicked')">Close</v-btn>
          <v-btn color="blue darken-1" :disabled="loading" flat @click="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>


<script>
import { Uploader } from "@/components/Mixins/fileUploader.js";
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, email, sameAs, alpha, numeric } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin,Uploader],
  validations: {
      name: { required, maxLength: maxLength(8) },
      email: { required, email },
      select: { required },
      checkbox: { required },
      password: { required, minLength: minLength(8), alpha, numeric },
      repeatPassword: {required, sameAsPassword: sameAs('password')},
  },
  props: ['user', 'dialog'],

  data() {
      return {
          errorMessage:'',
           e1:true,
           password:'',
           repeatPassword:'',
           status: 0,
           loading:false,
           picture:"",
           name: this.user.displayName,
           email: this.user.email,
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      if(this.emailErrors.length == 0 && this.nameErrors.length == 0 && this.passwordErrors.length ==0 && this.repeatPasswordErrors.length==0)
      {
      if(this.picture != "") {
        this.user.picture = this.picture;
      }
      this.user.displayName = this.name;
      this.user.email = this.email;
      this.user.password = this.password;
      this.$store.dispatch('ChangeUserInfo',{user:this.user,token:this.token}).then(token => {
          this.$store.dispatch("createToken", token.data.token);
          this.$emit('clicked');
        })
        .catch(err => {
          console.log(err)
        });
    }
    }
  },
    computed: {
      token() {
        return this.$store.getters.getToken
      },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.name.required && errors.push('Username is required.')
        return errors
      },
      passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength && errors.push("Must be at least 8 characters");
      !this.$v.password.required && errors.push("Password is required");
      this.$v.password.alpha  && errors.push("Should have at least one number");
      this.$v.password.numeric  && errors.push("Should have at least one letter");
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword && errors.push("Must match the first password");
      !this.$v.repeatPassword.required && errors.push("Password is required");
      return errors;
    },
    }
  }

</script>




// WEBPACK FOOTER //
// src/components/Partials/ChangePersonalInfo.vue